import { Module } from "vuex";
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import router from "@/router";
import moment from "moment";
import { base64ToKiloBytes, changeImageSize } from "@/utils/base64ImageHalper";
const surveyModule: Module<any, any> = {
  namespaced: false,
  state: {
    surveys: [],
    currentSurvey: null,
    currentSurveyForm: null,
    currentSurveyUnsavedChangesSurveyTemplate: null,
    currentSurveyResults: null
  },

  mutations: {
    setSurveys(state: any, payload: []) {
      state.surveys = payload;
    },

    setCurrentSurvey(state: any, payload: []) {
      state.currentSurvey = payload;
    },
    setCurrentSurveyUnsavedSurveyTemplate(state: any, payload: []) {
      state.currentSurveyUnsavedChangesSurveyTemplate = payload;
    },
    setCurrentSurveyForm(state: any, payload: []) {
      state.currentSurveyForm = payload;
    },
    setCurrentSurveyResults(state: any, payload: []) {
      state.currentSurveyResults = payload;
    },
  },

  actions: {
    async getSurveys({ commit }, showArchived) {
      let surveys = null;

      const facilityId = this.state.authModule.currentFacility;
      if (!showArchived)
        surveys = firebase.firestore().collection("surveys").where("facilityId", "==", facilityId).where("status", "in", ['Published', 'New']);
      else
        surveys = firebase.firestore().collection("surveys").where("facilityId", "==", facilityId);

      await surveys.get().then((querySnapshot) => {
        const surveyList: Array<any> = [];

        querySnapshot.docs.forEach((x) => {
          const thisRes = x.data();
          thisRes.id = x.id;
          if(thisRes.publishedDatetime )
            thisRes.publishedDatetime = moment(thisRes.publishedDatetime.seconds * 1000).toDate();
          surveyList.push(thisRes);
        });
        commit("setSurveys", surveyList);
      });
    },
    async getTriggeredSurveys({ commit }, showArchived,) {
      let surveys = null;

      const facilityId = this.state.authModule.currentFacility;
      surveys = firebase.firestore().collection("surveys").where("facilityId", "==", facilityId).where("audienceTriggered", "==", true).where("status", "in", ['Published']);

      await surveys.get().then((querySnapshot) => {
        const surveyList: Array<any> = [];

        querySnapshot.docs.forEach((x) => {
          const thisRes = x.data();
          thisRes.id = x.id;
          surveyList.push(thisRes);
        });
        commit("setSurveys", surveyList);
      });
    },


    async getSurvey({ commit }, { id, isRoute }) {
      const surveys = firebase.firestore().collection("surveys").doc(id);
      await surveys.get().then((querySnapshot) => {
        const currentSurvey = querySnapshot.data();
        if (currentSurvey.publishedDatetime != null)
          currentSurvey.publishedDatetime = moment(currentSurvey.publishedDatetime.seconds * 1000).toDate();

        if (currentSurvey != null) {
          currentSurvey.id = querySnapshot.id;
          commit("setCurrentSurvey", currentSurvey);
          //if (currentSurvey.status == 'Published' || currentSurvey.status == 'Archived') {
          const facilityId = this.state.authModule.currentFacility;
          const surveyResults = firebase.firestore().collection("surveyResults")
          .where("facilityId", "==", facilityId)
          .where("surveyId", '==', querySnapshot.id);
          surveyResults.get().then((querySnapshot) => {
            const surveyResultList: Array<any> = [];
            querySnapshot.docs.forEach((x) => {
              const thisRes = x.data();
              thisRes.id = x.id;
              thisRes.submittedDateTime = moment(thisRes.submittedDateTime.seconds * 1000).toDate();
              surveyResultList.push(thisRes);
            });
            commit("setCurrentSurveyResults", surveyResultList);
          });
          //}


          if (isRoute)
            router.push("/surveys/" + querySnapshot.id);
        }
      });
    },

    async getSurveyForm({ commit }, { id }) {
      const surveys = firebase.firestore().collection("surveys").doc(id);
      commit("setCurrentSurveyForm", null);
      return await surveys.get().then((querySnapshot) => {
        const currentSurvey = querySnapshot.data();

        commit("setCurrentSurveyForm", currentSurvey.template);

        return currentSurvey.template
      }).catch((er)=>{
        console.error('Survey form not found or not Published yet. ', er)
        alert("GET SURVEY FORM ERROR " + er.message)
        return null
      });
    },

    async saveCurrentSurveyConfig({ commit }, currentSurvey) {
      commit("setCurrentSurveyUnsavedSurveyTemplate", currentSurvey);

    },

    async createSurvey({ dispatch, }, name) {
      firebase
        .firestore()
        .collection("surveys")
        .add({
          "name": name, "status": "New",
          "r": [],
          "facilityId": this.state.authModule.currentFacility,
          "template": `{"title": "${name}"}`
        })
        .then((addSnap) => {
          console.log(addSnap.id);
          dispatch("getSurvey", { id: addSnap.id, isRoute: true });
        });
    },

    async updateSurvey({ dispatch, state, commit }, { id, audienceResidents, audienceFamily, audienceTriggered, audienceEmail, selectedMailingList, isAnonymizeSurvey, isPreliminaryQuestions }) {
      
      let template = state.currentSurveyUnsavedChangesSurveyTemplate

      if(template?.includes('logo') && template?.includes('base64')){
        const templateParsed = JSON.parse(template)
        if(templateParsed.logo?.length > 0){
          const kb = base64ToKiloBytes(templateParsed.logo)
          if(kb > 200){
            templateParsed.logo = await changeImageSize(templateParsed.logo, 200)
            template = JSON.stringify(templateParsed)
            console.log('logo resized')
          }
        }
        else{
          template = JSON.stringify(templateParsed)
        }
      }
      
    return await firebase
        .firestore()
        .collection("surveys")
        .doc(id)
        .update({
          "audienceResidents": audienceResidents,
          "audienceFamily": audienceFamily,
          "audienceTriggered": audienceTriggered,
          "audienceEmail": audienceEmail,
          "selectedMailingList": selectedMailingList,
          "isAnonymizeSurvey": isAnonymizeSurvey,
          "isPreliminaryQuestions": isPreliminaryQuestions,
          "template": template,
          "name": JSON.parse(state.currentSurveyUnsavedChangesSurveyTemplate).title
        })
    },

    async publishSurvey({ dispatch, state, commit }, { id }) {
      await firebase
        .firestore()
        .collection("surveys")
        .doc(id)
        .update({ "status": "Published", "publishedDatetime": firebase.firestore.Timestamp.now() })
        .then((addSnap) => {
          dispatch("getSurvey", { id: id, isRoute: false });
        });
    },

    async archiveSurvey({ dispatch, state, commit }, { id }) {
      await firebase
        .firestore()
        .collection("surveys")
        .doc(id)
        .update({ "status": "Archived", "archivedDate": firebase.firestore.Timestamp.now() })
        .then((addSnap) => {
          dispatch("getSurveys", false);
        });
    },
    async submitSurveyResult({ dispatch, state, commit }, { surveyId, r, surveyResult, id }) {
      const completedDateTime = firebase.firestore.Timestamp.now();
      const surveyData = (await firebase.firestore().collection("surveys").doc(surveyId).get()).data();

      await firebase
        .firestore()
        .collection("surveyResults")
        .doc(id)
        .update({
          "surveyId": surveyId,
          "facilityId": surveyData.facilityId,
          "dateTimeSubmitted": moment(new Date()).toDate(),
          "r": r,
          "submittedDateTime": completedDateTime,
          "surveyResult": surveyResult.data,
          "isAnonymizeSurveyResult": !!surveyData?.isAnonymizeSurvey,
          "isCompleted": true
        })
        .then(async (snap) => {  // this has to be done here currently.. cas myhub and fam hub cant acccess the survey directly to update it..  need a better solution TODO!

          await firebase
              .firestore()
              .collection("surveys")
              .doc(surveyId)
              .update({ "inProgress": firebase.firestore.FieldValue.arrayRemove(r) });

          await firebase
              .firestore()
              .collection("surveys")
              .doc(surveyId)
              .update({ "r": firebase.firestore.FieldValue.arrayUnion(r) });

            if(this.getters?.user?.isExternalPagesViewing === true){
              dispatch("userSignOut", {noRedirect: true})
            }
        })
    },
    async submitGuestbookSurveyResult({ dispatch, state, commit }, { surveyId, visitId, visitorId, surveyResult }) {
      const completedDateTime = firebase.firestore.Timestamp.now()
      const surveyData = (await firebase.firestore().collection("surveys").doc(surveyId).get()).data()

      await firebase
        .firestore()
        .collection("surveyResults")
        .add({
            "surveyId": surveyId,
            "facilityId": surveyData.facilityId,
            "dateTimeSubmitted": moment(new Date()).toDate(),
            "visitId": visitId,
            "visitorId": visitorId,
            "submittedDateTime": completedDateTime,
            "surveyResult": surveyResult.data,
            "isAnonymizeSurveyResult": !!surveyData?.isAnonymizeSurvey
        })
        .then((snap) => {  // this has to be done here currently.. cas myhub and fam hub cant acccess the survey directly to update it..  need a better solution TODO!
        });
    }
  },
};
export default surveyModule;
